<template>
  <div class="mw-panel commonOuterOrg">
    <mw-dialog ref="titleDialog" :title=" form.id ? $lang('编辑外单位') : $lang('新建公共外单位') " :close-on-click-modal="false">
      <div class="mw-toolbar" v-if="toolbarPosition!='BOTTOM'">
        <el-button type="primary" @click="closeTitleDialog">
           <i class="fa fa-mail-reply "></i>{{$lang('关闭')}}</el-button>
        <el-button  type="primary" @click="saveTitle"> <i class="fa fa-file-text-o"></i>
          {{$lang('保存')}}</el-button>
      </div>
       <div class="mw-toolbar__body">
          <template>
            <el-row>
              <el-form label-width="130px"  ref="ruleForm" :model="form" :rules="formRules">
                <el-col :span="24" >
                  <el-form-item :label="$lang('所属单位')"  prop="unitName" v-show="showOrg">
                    <el-input v-model="form.unitName" style="width: 80%" readonly></el-input>
                    <el-button type="primary" @click="showUnitDialog">选择</el-button>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item :label="$lang('所属单位ID')"  v-show="false">
                    <el-input v-model="form.unitId" style="width: 80%" ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item :label="$lang('外单位分类')" prop="code" >
                    <el-input v-model="form.code"  style="width:80%"></el-input>
                  </el-form-item>

                </el-col>

                <el-col :span="24">
                  <el-form-item :label="$lang('外单位名称')" prop="name">
                    <el-input v-model="form.name" style="width:80%"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item :label="$lang('外单位英文名称')" prop="name">
                    <el-input v-model="form.Englishname" style="width:80%"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item :label="$lang('外单位序列')">
                    <el-input-number v-model="form.sn" :controls="false"  :min="1" style="width:80%"></el-input-number>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item  :label="$lang('外单位编号')" prop="identifier">
                    <el-input v-model="form.identifier" style="width:80%" ></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
        </template>
        </div>
      <div class="mw-toolbar" v-if="toolbarPosition=='BOTTOM'" style="text-align: right;">
        <el-button  type="primary" @click="saveTitle"> <i class="fa fa-file-text-o"></i>{{$lang('保存')}}</el-button>
        <el-button type="primary" @click="closeTitleDialog"><i class="fa fa-mail-reply "></i>{{$lang('关闭')}}</el-button>
      </div>
    </mw-dialog>

    <split-pane :defaultSize="238" split="vertical">
      <template slot="paneL">
        <div class="mw-split-left">
          <mw-dialog size="mini_small" ref="unitDialog" title="选择外单位分类" :footerButton="unitFooterButton" :close-on-click-modal="false">
            <mw-tree :url="unitTreeUrl" :defaultParams="defaultUnitTreParams" :async="false" :threeState="true" ref="unitTree" :expandedFirst="true" :selectFirst="true" :multiple="false"></mw-tree>
          </mw-dialog>
          <div class="mw-toolbar">
            <el-button v-show="expandFlag==1" @click="expand" size="mini"><i class="fa fa-angle-double-down"></i>{{$lang('展开')}}</el-button>
            <el-button v-show="expandFlag!=1" @click="closed" size="mini"><i class="fa fa-angle-double-up"></i>{{$lang('折叠')}}</el-button>
            <el-button @click="changeOrg(1)" v-show="showCurOrg" size="mini"><i class="fa fa-user-circle-o"></i>{{$lang('本单位')}}</el-button>
            <el-button @click="changeOrg(2)" v-show="showAllOrg" size="mini"><i class="fa fa-users"></i>{{$lang('全集团')}}</el-button>
            </div>
          <div>
            <mw-tree :url="outerOrgTreeUrl" :autoLoad="false" :async="true"  :multipleLeaf="true"
                     :dragEnable="true" :defaultParams="defaultTreeParams"  :expandedFirst="true" ref="groupTree" @changed="changed"  :selectFirst="true" ></mw-tree>
          </div>
        </div>
      </template>
      <template slot="paneR">
        <div class="mw-split-right">
          <toolbar-table :layout="layout"  ref="aa" :pagination="false">
            <span slot="dropDown" v-show="userInfo.unitAdmin ||!isLimit">
              <el-dropdown trigger="hover" @command="handleSortCommand" v-show="userInfo.unitAdmin ||!isLimit">
                <el-button class="el-dropdown-link">
                  {{$lang('排序')}}<i class="el-icon-caret-bottom el-icon--right"></i>
                </el-button>
                <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown" style="width:100px;">
                  <el-dropdown-item command="sort" >{{$lang('排序')}}</el-dropdown-item>
                  <el-dropdown-item command="top">{{$lang('置顶')}}</el-dropdown-item>
                  <el-dropdown-item command="bottom">{{$lang('置底')}}</el-dropdown-item>
                  <el-dropdown-item command="up">{{$lang('上移')}}</el-dropdown-item>
                  <el-dropdown-item command="down">{{$lang('下移')}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
          </toolbar-table>
        </div>
      </template>
    </split-pane>
  </div>
</template>
<script>
  import loadUsers from './user/loadUsers'
  import { mapGetters } from 'vuex';
  export default {
    components: {
      loadUsers
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'expUser'
      ])
    },
    data() {
      let me = this;

      return {
        isLimit : false,
        layout: [],
        expandFlag:1,
        selectUnitId: '',
        toolbarPosition:(window.$Env && $Env.toolbarPosition) || 'TOP',
        showOrg:true,
        showCurOrg:false,
        showAllOrg:false,
        form:{
          id:'',
          code: '外单位',
          name: '',
          Englishname: '',
          sn: 1,
          unitName: '',
          unitId:'',
          create_user:'',
          identifier:""
        },
        outerOrgTreeUrl:this.mwUrl('/api/org/getGroupTreeByType'),
        defaultTreeParams:{type:'common_outerOrg'},
        curSelParams:{type:'common_outerOrg'},
        selCode:'',
        selUnitId:'',
        selUnitName:'',
        formRules:{
          unitName:[
            {required: true, message:$lang("请选择所属单位"), trigger: 'change'}
          ],
          name:[
            {required: true, message:$lang("请输入外单位名称"), trigger: 'blur'}
          ]
        },
        defaultParams:{
           type:'common_outerOrg'
         },
         defaultUnitTreParams:{deep:true,isContainSelf:false,parentId:""},
         unitTreeUrl: this.mwUrl('/api/org/getUnitTreeContainSelf'),
         unitFooterButton: [
          {label: '取消', func: me.selectUnitCancel,type: "default"},
          {label: '确定', func: me.selectUnitSure}
        ],
      }
    },
    mounted() {
        let me = this;
        var isSysAdmin = this.isSysAdmin();
        var sysAdminShowAllUnit = true;
        if(window.$Env && window.$Env.dataManagementByUnit){
          sysAdminShowAllUnit = false;
        }
        if((this.userInfo.developer || isSysAdmin) && sysAdminShowAllUnit){
          this.showCurOrg = true;
        }
        if(!this.userInfo.developer){
          if(this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0){
            me.defaultParams.unitId= this.$store.getters.curUnit[0].id;
            me.curSelParams.unitId = me.defaultParams.unitId;
            if(!isSysAdmin || !sysAdminShowAllUnit){
              me.defaultTreeParams.unitId = me.defaultParams.unitId;
              me.defaultUnitTreParams.parentId = PF.userInfo.initunitid
            }

          }
        }else{
            this.defaultParams.unitId= this.userInfo.owner;
        }
        if(window.$Env && window.$Env.showOuterOrg){
          me.defaultParams.unitId = null;
          me.defaultTreeParams.unitId = "";
          me.showOrg = false;
        }
        var p = me.$parent.params
        var buttonspan = 16,searchspan = 6,searchOffset = 2;
        if(p && p.selDialog){
          buttonspan = 13,searchspan = 10,searchOffset = 1;
        }
        me.layout = [
           [{
             span:0,
             type: 'menu',
             label:$lang('公共外单位管理'),
             api: 'org.listGroupDataByType',
             defaultParams:me.defaultParams,
             columns: [
               {type: 'selection'},{prop:'sn',width:'55',label:$lang('序号')},
               {prop: 'name',label: $lang('外单位名称'),slot:{type:"href",func:me.openForm}},
               {prop: 'Englishname',label: $lang('外单位英文名称'),width:'220',tooltip:true},
               {prop: 'identifier',label: $lang('外单位编号'),width:'105',tooltip:true},
               {prop: 'create_user', label: $lang('创建者'),width:'100',tooltip:true},
             ]
           },{
             span: buttonspan,
             type: 'button',
             items: [{
               label: $lang('添加'),
               func: me.addTitle
             },{
               label: $lang('删除'),
               func: me.deleteGroup,
               icon:"el-icon-delete"
             }],suffixSlot:"dropDown"
           },{
             span: searchspan,
             type: 'searchText',
             name:'name',
             tip:$lang('外单位名称'),
             offset: searchOffset,
             func: me.search
           }]
       ]

      this.mwRef('groupTree').renderTree();
     },
    methods: {
      changed(data){
        let me =this;
        if(!data.id){
          return;
        }
        let unitText = "";
        if(data.code){
          me.defaultParams.unitId = data.unitId;
          unitText = data.unitName;
          me.defaultParams.code = data.code;
          me.selCode = data.code;
        }else{
          delete me.defaultParams.code;
          me.selCode = "";
          me.defaultParams.unitId = data.id;
          unitText = data.text;
        }
        me.selUnitId = me.defaultParams.unitId;
        me.selUnitName = unitText;
        me.reloadData();
      },
      reloadData(){
        var me = this;
        var tableObj = me.mwRef('aa');
        if(!tableObj || !tableObj.refreshTableDataList) return;
        $.post("/api/org/listGroupDataByType",me.defaultParams,function(res){
          tableObj.refreshTableDataList(res.result);
        })
      },
      expand() {
        this.expandFlag = 2;
        this.mwRef('groupTree').openAll();
      },
      closed() {
        this.expandFlag = 1;
        this.mwRef('groupTree').closeAll();
      },
      changeOrg(type){
        if(type&&type=="1"){
          this.showAllOrg=true;
          this.showCurOrg=false;
          if(this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0){
            this.defaultTreeParams.unitId = this.$store.getters.curUnit[0].id;
            this.mwRef('groupTree').refresh();
          }
        }else{
          this.showAllOrg=false;
          this.showCurOrg=true;
          this.defaultTreeParams.unitId = "";
          this.mwRef('groupTree').refresh();
        }
      },
      addTitle(){
        this.resetFields();
        if(this.userInfo.developer){
          this.form.unitId = this.userInfo.owner;
          this.form.unitName = "美络科技";
        }else{
          this.form.unitId = this.selUnitId || this.$store.getters.curUnit[0].id ;
          this.form.unitName = this.selUnitName || this.$store.getters.curUnit[0].name;
        }
        this.form.create_user = this.userInfo.name;
        this.form.code = $lang(this.selCode || "外单位");
        this.showDialog('titleDialog');
      },
      openForm:function(data){
        let fd = {};
        fd = _.assign(fd,data)
        this.form = fd;
        this.showDialog('titleDialog');
      },
      isSysAdmin(){
        if(PF.userInfo.allIdentityRoleNames && PF.userInfo.allIdentityRoleNames.indexOf("系统管理员") !=-1){
          return true;
        }
        return false;
      },
      deleteGroup(data){
        let me = this;
        if(!data || data.length===0){
          this.mwMsg('warning', '请选择数据');
          return;
        }
        let ids = [];
        $.each(data,function(i,d){
          ids.push(d.id);
        })
        me.mwConfirm('您确定要删除此外部单位吗?').then(() => {
          PF.ajax("api/org/deleteAddressBookGroup",ids).then((res)=>{
              if (res.result > 0) {
                me.mwMsg("删除成功");
                me.refreshData();
              }
          });
        })
      },
      closeTitleDialog(){
        this.resetFields();
        this.closeDialog('titleDialog');
      },

      refreshData(noRefreshTree){
        if(!noRefreshTree){
          // this.defaultTreeParams.t = Date.now();
          this.mwRef('groupTree').refresh();
        }else{
          this.reloadData();
        }
      },
      saveTitle(){
        var me=this;
        me.mwRef('ruleForm').validate((valid) => {
          if (valid) {
            me.form.type = "common_outerOrg";
            $.post("/api/org/saveOuterOrg",this.form).then(function(data){
                me.mwRef('titleDialog').hide();
                me.refreshData();
                me.resetFields();
            });
          }
        });
      },
      handleSortCommand(command) {
        let me = this;
        let multipleSelection =  this.mwRef('aa').getMultipleSelection();
        me.doSortSN(command,multipleSelection);
      },
      sort(){
          this.doSortSN("sort");
      },
      up(data){
        this.doSortSN("up",data);
      },
      down(data){
        this.doSortSN("down",data);
      },
      top(data){
        this.doSortSN("top",data);
      },
      bottom(data){
        this.doSortSN("bottom",data);
      },
      doSortSN(flag,data){
        let me = this;
        let params = _.assign({},me.defaultParams);
        params.flag = flag;
        if(flag != "sort"){
          if(!data || data.length != 1){
            this.mwMsg('warning', $lang('请选择一条数据'));
            return;
          }
          params.id = data[0].id;
        }
        PF.ajax("api/org/updateGroupSN",params).then((res)=>{
          if(res.result){
            me.reloadData();
          }
        });
      },
      selectUnitCancel() {
        this.closeDialog('unitDialog');
      },
      showUnitDialog() {
        let me = this;
        me.selectUnitId = me.form.unitId;
        me.isExportGroup=false;
        this.showDialog('unitDialog');
      },
      //单位选择
      selectUnitSure() {
        let me=this;
        let tree=this.mwRef('unitTree');
        let data = tree.getSelected();
        if (!data) {
          this.mwMsg('warning', '请选择单位');
        } else {
            me.form.unitId = data.id ;
            me.form.unitName = data.text;
            this.selectUnitCancel();
        }
      },
      showDialog(a){
        this.mwRef(a).show();
      },
      closeDialog(a){
        this.mwRef(a).hide();
      },
      closeGroupDialog(){
        this.closeDialog("dialog");
      },
      resetFields() {
        var me = this;
        me.form.id = "";
        me.form.unitName = "";
        me.form.unitId =  "";
        me.form.code = "";
        me.form.name = "";
        me.form.sn = "";
        me.form.create_user = "";
        me.form.identifier = "";
      }
    }
  }
</script>
<style scoped>
.toolbar-dialog {
      padding: 5px 10px;
      line-height: 35px ;
      margin-bottom: 5px;
      background-color: #f1f1f1;
   }

  .el-tree-node__content .el-checkbox {
    display: none;
  }

  .el-input, .el-textarea {
    width: 80%;
  }

  .el-form-item__label {
    line-height: 30px;
    word-break: break-word;
  }
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/commonOuterOrg.vue